
	import Vue from 'vue';
	import Component from 'vue-class-component';

	const Props = Vue.extend({
		props: {
			/** Set min-height to 500px */
			minHeight: {
				type: Boolean,
				default: false
			},
			/** Remove shadow from VCard */
			noShadow: {
				type: Boolean,
				default: false
			},
			/**
			 * Customize the class binded to the VCard
			 * 'page-card' will be applied regardless of this property.
			 */
			cardClass: {
				type: String,
				default: 'pa-0'
			}
		}
	});

	/**
	 * PageCard is a component that displays a
	 * VCard with specific parameters
	 */
	@Component({
		// Disable attributes inheritance since we bind them to the VCard
		inheritAttrs: false
	})
	export default class PageCard extends Props {
		/** The CSS classes to apply to the VCard */
		get computedClass() {
			return [
				{
					'min-height': this.minHeight,
					'no-shadow': this.noShadow
				},
				this.cardClass
			];
		}
	}
